import { render } from "./AuthLayouts.vue?vue&type=template&id=98b7f4b0"
import script from "./AuthLayouts.vue?vue&type=script&lang=js"
export * from "./AuthLayouts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__